import React, { useEffect, useState } from 'react';
import { useDispatch } from 'react-redux';
import { useHistory } from 'react-router-dom';
import { useAppSelector } from '../../app/hooks';
import { AMIAlert, AMIButton, AMIModal } from '../../ui-components/UiComponents';
import { customerActions, customerDetailsSelector } from '../../features/customerSlice';
import { refreshAuth } from '../../utilities/APIUtilities';
import dayjs from 'dayjs';
import utc from 'dayjs/plugin/utc'
import timezone from 'dayjs/plugin/timezone'
import { bookingActions } from '../../features/bookingSlice';
import { appDataActions } from '../../features/appDataSlice';
import { appDataSelector } from '../../features/appDataSlice';
import { refreshCognitoAuth } from '../../auth/cognitoAuthService';
import {jwtDecode} from "jwt-decode";

dayjs.extend(utc);
dayjs.extend(timezone);

let showModal: any;
let logout: any;
let interval: any;
let refreshAccessToken: any;

const InactivityModal = () => {

  const history = useHistory();
  const dispatch = useDispatch();
  const customer = useAppSelector(customerDetailsSelector);
  const { apiConfig, isWl } = useAppSelector(appDataSelector);

  const [isVisible, setIsVisible] = useState(false);
  const [isSpinning, setIsSpinning] = useState(false);
  const [refreshError, setRefreshError] = useState(false);
  const [errorCount, setErrorCount] = useState(0);
  const [inactiveTime, setInactiveTime] = useState(0);

  useEffect(() => {
    handleTimer();

    return () => {
      cancelTimer();
    }
  }, []);

  showModal = () => {
    setIsVisible(true);
  }

  logout = () => {
    dispatch(customerActions.logOut());
    dispatch(bookingActions.resetState());
    dispatch(appDataActions.resetState());
    history.push('/auth');
    window.location.reload();
  }

  refreshAccessToken = async () => {

    try {
      let remainingMins= getRemainingMins()
      clearInterval(interval);
      if (remainingMins <= 0) {
        logout();
      } else if (remainingMins <= 30) {
        console.log("Refreshing token")
        return isWl ? await refreshWlAccessToken() : await refreshNebeAccessToken();
      } else {
        return true;
      }
    } catch (error) {
      console.error('Error refreshing access token:', error);
    }
  };

  const refreshWlAccessToken = async() => {
    let tokenResponse = false;
    const response = await refreshCognitoAuth(customer.auth.refreshToken);
    if (response?.['AccessToken']) {
      tokenResponse = true;
      const newToken = jwtDecode(response['AccessToken']);
      const expiration : any = newToken.exp;
      // const expiration = dayjs().add(1, 'h').toISOString();
      dispatch(customerActions.updateField({
        field: 'auth',
        value: {
          ...customer.auth,
          accessToken: response['AccessToken'],
          expiration: dayjs(expiration * 1000).tz('Europe/London').format()
        }
      }));
      dispatch(appDataActions.setApiConfigAuthorizationHeader(`Bearer ${response['AccessToken']}`));
    } else {
      logout();
    }
    return tokenResponse
  }

  const refreshNebeAccessToken = async() => {
    const response = await refreshAuth(apiConfig);

    const newToken = jwtDecode(response.data.auth.accessToken);

    const expiration : any = newToken.exp;
    if (response.data.auth?.accessToken) {
      dispatch(customerActions.updateField({
        field: 'auth',
        value: {
          ...customer.auth,
          accessToken: response.data.auth.accessToken,
          expiration: dayjs(expiration * 1000).tz('Europe/London').format()
        }
      }));
      dispatch(appDataActions.setApiConfigAuthorizationHeader(`Bearer ${response.data.auth.accessToken}`));
    } else {
      logout();
    }
    return response
  }

  const handleTimer = () => {

    interval = setInterval(() => {
      let remainingMins = getRemainingMins()
      setInactiveTime(60 - remainingMins);
      if (remainingMins <= 5) {
        showModal(true);
      }

      if (remainingMins <= 0) {
        logout();
      }
    }, 1000);
  }

  const getRemainingMins = () => {
    let timerOffset = 1 //change this to -53 or -48 to shortened timeout for testing
    let remainingMins = dayjs(customer.auth.expiration).diff(dayjs(), 'm') + timerOffset
    if(isNaN(remainingMins)) {
      const newToken = jwtDecode(customer.auth.accessToken);
      const expiration : any = newToken.exp;
      remainingMins = dayjs(dayjs(expiration * 1000).tz('utc').format()).diff(dayjs(), 'm') + timerOffset
      dispatch(customerActions.updateField({
        field: 'auth',
        value: {
          ...customer.auth,
          accessToken: customer.auth.accessToken,
          expiration: dayjs(expiration * 1000).tz('utc').format()
        }
      }));
    }
    return remainingMins;
  }

  const cancelTimer = () => {
    clearInterval(interval);
  }

  const onContinueInactivityModal = async() => {
    setRefreshError(false);
    setIsSpinning(true);
    const success: any = await refreshAccessToken();
    setIsSpinning(false);

    if (success) {
      setIsVisible(false);
    } else {
      setErrorCount(errorCount + 1);
      if (errorCount >= 5) {
        history.push('/auth');
      }
      setRefreshError(true);
    }
  }

  return (
    <>
      {isVisible &&
        <AMIModal
          title="Attention"
          width="50%"
          close={onContinueInactivityModal}
          buttons={[<AMIButton
            key={Math.random()}
            variant='default'
            size="large"
            onClick={logout}
          >Logout
          </AMIButton>,
          <AMIButton
            key={Math.random()}
            variant='primary'
            size="large"
            isSpinning={isSpinning}
            onClick={onContinueInactivityModal}
          >Continue
          </AMIButton>
        ]}
        >
          You have been inactive for {inactiveTime} minutes, please press continue or logout
          {refreshError &&
            <AMIAlert
              variant="error"
              style={{marginTop: '12px'}}
            >
              Error: Please press continue or logout and try again
            </AMIAlert>
          }
        </AMIModal>}
    </>

  )
}

export { logout, showModal, refreshAccessToken };
export default InactivityModal;